import { useEffect, useState } from "react"
import ReactDOM from "react-dom"
import "./style.css"

export function Portal({ children }) {
  const [container] = useState(() => document.createElement("div"))

  useEffect(() => {
    document.body.appendChild(container)

    return () => {
      document.body.removeChild(container)
    }
  }, [container])

  return ReactDOM.createPortal(children, container)
}

export function Modal({
  active,
  setActive,
  children,
  className,
  onClose,
  wrapClassName,
  template,
}) {
  if (!active) return null

  return (
    <Portal>
      <div
        className={`${wrapClassName}
        fixed inset-0 bg-[rgb(0,0,0)]/20 z-[1000]
        flex justify-center items-center
      `}
        style={{ left: 0, top: 0, right: 0, bottom: 0 }}
        onClick={onClose}
      >
        <div
          className={`${className} w-full bg-white rounded-xl ${
            template ? "" : "p-7"
          }`}
          onClick={(e) => e.stopPropagation()}
        >
          {children}
        </div>
      </div>
    </Portal>
  )
}
